import * as React from 'react';
import { Translation } from 'react-i18next';
import {
  DoublePurchaseResponse,
  DoublePurchaseValidationResult,
} from '../CheckoutPageTypes';
import s from './DoublePurchaseModal.scss';
import { RootStore, withInjectedRootStore } from 'providers';
import classNames from 'classnames';
import { Modal, MessageModalLayout, Text } from '@wix/design-system';

export interface DoublePurchaseModalProps {
  isOpen: boolean;
  onClose(): void;
  additionalInfo: {
    info: DoublePurchaseResponse['existingPackageInfo'];
    validationCode: DoublePurchaseValidationResult;
  };
  rootStore: RootStore;
}

class DoublePurchaseModalComp extends React.Component<DoublePurchaseModalProps> {
  private readonly getView = () => {
    const { additionalInfo, rootStore } = this.props;
    const { isDynamicOffering } = rootStore.appStore.appContext;
    switch (additionalInfo.validationCode) {
      case DoublePurchaseValidationResult.ALREADY_DELIVERED: {
        return {
          iconClass: s.alreadyDelivered,
          reason: 'double_purchase_validation.alreadyUpgradedPlan',
          explanation: isDynamicOffering
            ? 'double_purchase_validation.alreadyUpgradedPlan_alreadyDelivered_dynamic'
            : 'double_purchase_validation.alreadyUpgradedPlan_alreadyDelivered',
          confirmationButtonText: 'double_purchase_validation.viewPlanButton',
        };
      }
      default: {
        return {
          iconClass: s.pending,
          reason: 'double_purchase_validation.alreadyUpgradedPlan',
          explanation: isDynamicOffering
            ? 'double_purchase_validation.alreadyUpgradedPlan_pendingDelivery_dynamic'
            : 'double_purchase_validation.alreadyUpgradedPlan_pendingDelivery',
          confirmationButtonText: 'double_purchase_validation.manageSiteButton',
        };
      }
    }
  };

  handleConfirmation = () => {
    const { additionalInfo, rootStore } = this.props;
    const { myAccountUrl, siteGuid, biLogger } = rootStore.appStore.appContext;
    biLogger.logDoublePurchasePopupCTA();
    const redirectUrl = `${myAccountUrl}sites/${siteGuid}`;
    if (
      additionalInfo.validationCode ===
      DoublePurchaseValidationResult.ALREADY_DELIVERED
    ) {
      window.location.assign(`${redirectUrl}/manage-premium/plans/`);
    } else {
      window.location.assign(redirectUrl);
    }
  };

  render() {
    const { isOpen, onClose, additionalInfo } = this.props;
    // todo change key not to include plan name and cycle
    const cycle = `cycle_entry.${additionalInfo?.info?.cycle}.name` || '';
    const planName = additionalInfo?.info?.planName || 'current';
    const {
      reason,
      confirmationButtonText,
      explanation,
      iconClass,
    } = this.getView();
    return (
      <Translation>
        {(t) => (
          <Modal
            dataHook='double-purchase-modal'
            isOpen={isOpen}
            contentLabel='Double Purchase Modal'
            shouldDisplayCloseButton={false}
            onRequestClose={onClose}
          >
            <MessageModalLayout
              dataHook='double-purchase-modal-content'
              title={t('double_purchase_modal.title')}
              primaryButtonText={t(confirmationButtonText)}
              primaryButtonOnClick={this.handleConfirmation}
              onCloseButtonClick={onClose}
              illustration={
                <div
                  className={classNames(s.icon, iconClass)}
                  data-hook='icon'
                />
              }
            >
              <div className={s.container}>
                <div>
                  <Text dataHook='reason'>{t(reason)}</Text>
                  <div className={s.explanation}>
                    <Text dataHook='explanation'>
                      {t(explanation, { cycle: t(cycle), planName })}
                    </Text>
                  </div>
                </div>
              </div>
            </MessageModalLayout>
          </Modal>
        )}
      </Translation>
    );
  }
}

export const DoublePurchaseModal = withInjectedRootStore(
  DoublePurchaseModalComp,
);
